/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getWWWListing = (params) => makeApiCall(`/footprint/www/list`, `POST`, params);

export const postWWWStore = (params) => makeApiCall(`/footprint/www/store`, `POST`, params);

export const getAgenda = (params) => makeApiCall(`/footprint/www/view`, `POST`, params);

export const postArchiveAgenda = (params) => makeApiCall(`/footprint/www/delete`, `POST`, params);

export const postRestoreAgenda = (params) => makeApiCall(`/footprint/www/restore`, `POST`, params);
